import { ArrowUpFromLine } from "lucide-react";

export function DndOverlay() {
  return (
    <div className="z-20 absolute inset-0 h-full p-4 flex flex-col items-center justify-center gap-2 bg-muted rounded-2xl">
      <div className="bg-background rounded-full p-2 ring-1 ring-foreground/10">
        <ArrowUpFromLine className="size-4 text-foreground" />
      </div>
      <p className="text-sm text-foreground">Drag and drop files here</p>
    </div>
  );
}
